import Gateway from '@/utils/Gateway';
import urlTool from '@/utils/urlTool';
import { showDialog, setMaxWidthDialog, addDialogClass } from 'src/pages/mng/third_account/weworkCombine/api/dialog.js';

export function getInstallCallBackByUrlParams() {
    const suiteId = urlTool.getUrlParameter('suite_id');
    const isInstallCallBack = urlTool.getUrlParameter('wwappinstall') === '1';

    return {
        suiteId,
        isInstallCallBack
    };
}

export function handleAppInstallUrl(suiteId, installUrl) {
    let jumpUrl = urlTool.removeURLParameter(window.location.href, 'suite_id');
    jumpUrl = urlTool.removeURLParameter(jumpUrl, 'wwappinstall');
    jumpUrl = urlTool.addUrlParameter(jumpUrl, 'suite_id', suiteId);

    let handledInstallUrl = urlTool.removeURLParameter(installUrl, 'jump');
    // handledInstallUrl = urlTool.addUrlParameter(handledInstallUrl, 'jump', encodeURIComponent(jumpUrl));
    handledInstallUrl = handledInstallUrl.replace('~jump~', encodeURIComponent(jumpUrl));
    return handledInstallUrl;
}

// 企业微信退出引导弹框
function showWeworkQuitDialog() {
    showDialog({
        title: '请先退出当前已登录的企业微信',

        // eslint-disable-next-line no-unused-vars
        render(h) {
            return (
                <p class="app-install-error-dialog-text">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACQCAMAAACF3Kb9AAABsFBMVEXh5vAAAADf5e/f5O/i5vHj5/H////19fU9WIDp6ut3ZW7h5vDo6erm5+htgZ/h4eLY2drr7O3/g0U+WYFQaIzM1N7Hz9u7dFnv8fV+kKtMZYr4+vuFmLHa3+egrsLi4+Swu8yTo7mFcXfq7fLl6e7S2OKYp71+kq5DXYT9/f5JYohGYIbs7/PU2uRziKZofZ3n6/C4w9Kqt8mDlK9Ta47Aytfy9PfCy9itucp1iqefbWLi5u3c4engv7Jhd5hbcpT6+/zf5Ou0v897jqpBW4N4i6hWbpB6Zm709vjW2+XO1uCRoLdke5tcdZjK0t28xtSisMSWpbvoxrhsgaFZcJKdq7+aqb6IdHlaXnfMeFTvf0q+yNZvg6JkeZrX3eaOnraJmrJedJaYgoSOeX2otMelssWLnLRxhaOWf4JAWoL2+Prxzr7cvLBpgKCBbnWZbGTEzdnIqqOsk5GqcF6mtMdTXXnNrqadhYaTfYBPZ4yki4tFWn7Ep6Fcc5R9anKGaGnZua7RsqlPY4RZYXu9oZyqkI/ce0+4nJmmjY2Ramf61cSxl5TBinbEdVaScXDphVfV4VQ/AAAABnRSTlPvAICQj3/lX0gkAAAJ3UlEQVR42uza/VPScBzAceuq+9y64wc3Vts5DpDZ2kSEDfEBMGGMAA+TQDJEBUQlzadKxdK0tOeHf7nvF4i0wPC6kkved34dbv7g6758hmLbpatt11s1UNuVS21X8hK0aiAlf7mtTYFWDSW1tV2H/7Xng6sPHrwcHCR+WYMPHgR/WQcH4Tdd/4+xnrU/JIjJ9vYnv6w3COLGL2t7+4XGuvGeIAZv1FhXCWK1xnqRsZ4TZ6yF1cJqeGY13IWfWS2sM2A9fHMWrIcPmwhLYquHqlYAlCbBbyJJ9H2F41+QSChHsX84s5LNPLM6fNXDYTsLiECvgAi1i3fMzs7KWmIYBF+64iTGdR1z9gyUMyWgnOCXZUbUdaD8Uh2srR2CMB9t4LaJcmZPM2BRt6jyj8swgV0VQOuBUqJVB5W8PMWGKLBobDhTY+OhbG7ON+RMR9bUBT06QemtIcttq8vXtYB454dCoRDXG0JNs0C57T6LzRX1+exu7QTWl5dEpZxnJ5iNraNiL9DDd28R1hI6OMgS1V6+PAes+dtd+InD3KFp/VBCgIiFLOaNKN5txGlCWuYG4o4Z0qLNR8nqbtORcCyDAYwBade4S0eoAgDLxsMJSZgN4IvGnZRiHKBw3RSCLILV5uoBUHgFjvX62IDP7W9nPVuLi4ubGGvjRQVreet8B7wapXkRYw0BCMxNG0R6SXZm3NI/jnL0JsYVyh66GZW9TtGS8TFQxbp/EsslRwP+lDPaSacoAHXU59C0mbWSqDzBmm72T0wkEmyKBco6qkwjLIEdiLJ1sJAN2lmbaGd5mgorzXl7dWUsVNiEsdDBRD9aSQNegZxxa2R8VOucGh2ui8XnuYCoDYcZTVPR2e4Re7Q7JZavEY19tMwwfFgEAMoybe1EWPEUHyFPYFXvhsFkEmF5tnO53HoJazOZXFxKJpOerfO9G447VR8iKWMJnFzBivMagMjtAkpae2QshsPhET5sqYtlII0BdGnYCzhVofzucTGQEAA1Z0+PGXWOVAZQlH6YRTtr3ruw4BXgWK92iEorB8v75uzS8v7+/vJHPLNiHo/nA/qIbZ/rgCdHGAhwFMKyKErcMZKpYME9n1AwpQA3sMbNRShcprcuFh3h/Ywh391vMCAvIeOIPmaLGdqEr9JYVuYsFkYRVYQVjkshm2to2umajtfGCq7klpPZZfO73F5uI4jwzGbz9pIZtXeuWLY7s/6O7gGEda2vr0+/AN+x2KhJFxoGlDjG8F4ZcFT9nWXNuxnG0H8nhLGErr5HdJTX6+kRGwiBiTFuTI7fcnK00Q/KUNTVa3MlxoS0nj2B9Wn1x8jCWCtHsbeej0EiebhXmVnmw5XqJaur/xqrYOy02+1uZ3lnKSJUsWA3xMlkyXPcy1NkF42K3j3taegXSJl2iSQJpHehJ+PXxzNF2QBSwmS4F0Gvw0wJhpmCTFg3ytlcfr0/7yNrDfgq1t7e1mYsSRDbnpUKVs5jPscBL1o6JEmaGopXBvwPLEHHdc6xgBKLCAuG06ipzjpY5L25zBo/JTgH8gskfjxlF2166Z6DYtEDsPP9uOl5ANCtqaWXDgE9p4NTsHZihweH5hf75qbBGrgpoFXixn/GkgzT/ridT5dEMNbpT0Obu5seikgdYSFjzSAe/0gAEBZr1CuAsiMllAF/6rBDCYvVj2gnsb5OViXeLh29W9/IrhDBo2QdrDdv/jUWMwM42QTePJTrcZCqLjEypgAUZrnUgFDC8s7h+vvqYLFeAYz+gKUHYIYvSg53WlUYvQSqwSpiLJcJR2Ms34zAum2uWRc9556qNeBRG54tz+FWNru4mM3miO2lGOpDDGduut8N42NPbRKgyGFTahQ99rG7JlyXtQ4WLu9/aisAGlE69dYuiEZ6gkSK8wgbHGNduBSDt5eSthsVYz7BCnJXbay99RyRfLu+iTo4OCJyB1uL5XY2V5oOi2ShGr7bq0WEgFO1U7AoVihfVDpRUCjyxykRcKxYOi0oKqmIJL7o5N1wsKpFHC+4Evz5CPXkSXNgNVKhLNP6419jtbDOsWeTn8+CNTl5kbFa7+60sP5KaGZ9Psvb928u9sxq/a/DX6yF1cJqqBbWN3brp1VVIIzj+O63vLtiYjQSLRkwsyJLitAisK79I06bOtXinBMIQQvfP3dKKZe6ulzvfEGc9Yd5HuZvxrF+iTLGsSDKmMASWM8EVo4EVo4EVo4EVo4EVo4EVo4EVo4EVo4EVo4EVo4EVo4EVo4KhuW7rkddhmfhEDzDQiqmGUhnUdgGMlcULGpbJaXSVE1vUPXxqHYGb19NW61n3SHeuUcVkypyVAgsf+uMl9s+MW6ep58t8Lo18Mx7ymZ9vEdOSosuVXQayFxBsNz7oh+ogN3yYCgRMD98Vg8Lpi1rvV7vTsCzI0d23dq0HEP5byzmM2SpKFiUngKLUvLZpNQgDJtbpXKV7M7NdBxzvADYSJnVwWjYMWs2gPLXG8tqWMhSQbAOkqQvu5IkLWcS74QNN1hL9dsIgK0vQDpBQwO8M1jTNMsMw5v7wipfXGSpIFjDXi8aT/jEtT56PCPB2u6RYJ3NEgPQPALwN7cSfGf1wtoPkK1iYPFGgQFAr4G0bWCjEDKR6tqKn4leh6dhLidYoHIId7t3Eyx2lJGpQmHZK3u/RSQ9sG7drinR0JzEWIjvT3Pn81zwDlM/wZJNGxkrBpYvD8az1pkcnFIgg2P9yHIkUZzMEgy9+cJa3nh98PxAi7Fc5ZshW8XAWl8dZznRfDa6HiMGJDuLgk2mxKjM3zeL8EI8kvoxlrEbIlsFwRre5dVzZ42cqc8s+sJC2CZWRX5hHfGq146xrCoyVhCsZMGz+dUxKT2X+BiORl8SjSWnXhrrv3/B8+TAaG7NttaNvJmGze5ycRKs+syCS4iyIaS8I/EcMkNVVW0pq1VF5dnIVEGwvN4mCKu/T8DJ6ZoM34phtBUKkHV7dmbQLvrO1HWnpT9qw1D4rxLo+vWq8wbIUlGw6j+/1wgZeHK1zsn4x1wApPHz4QF+qZxqiLBZSuchS0XB+hcTWALrmcD6044dGyEMAwEQfNuBxsNrwBkZAdRA/6WhoYK/SIHuStjwQGKBxAKJBRILJBZILJBYILFAYoHEAokFEmtmA+thxQbW3YoNrG7FBlZasYF1WjGxxPonFkgskFggsUBigcQCiQUSCyQWSCyQWCCxQGKBxAKJNbPVtzLFulYuk2G1lXtmilXX6ilWubOLVe7qKVa18yVWuRRLLBDB6mKJ1ZpYILFAYoHEAokFEgskFkgskFggsUBigcQCiQUSCyQWSCyQWCCxQGKBxAKJBRILNBcr2toBrIj9/W0rV8f6HLEdcbNCsW8/VozzGSbZTgYAAAAASUVORK5CYII=" />
                </p>
            );
        },
        confirmText: '去退出',
        cancelText: '我已退出',
        confirm(e) {
            e.preventDefault();
            window.open('https://work.weixin.qq.com/wework_admin/frame');
        }
    });
}

function getAppInstallResult(options) {
    const { suiteId, refreshFn } = options || {};

    Gateway.get('/v1/corp/wework/AppInstallResult', {
        suite_id: suiteId
    }).then(() => {
        if (typeof refreshFn === 'function') {
            refreshFn();
        }
    });
}

function handleErrorResult(options) {
    const { statusCommentObj, name, isBind, reInstallFn, originOptions } = options || {};
    const { status, corp_name: corpName } = statusCommentObj || {};

    const reInstallhandle = () => {
        if (typeof reInstallFn === 'function') {
            reInstallFn();
        }
    };

    let dialog;

    // 0 - 成功
    // 1 - 调企微接口失败
    // 2 - 扫码企业和绑定的企业不一致
    // 3 - 主体信息不相同
    // 4 - 企微未认证主体信息
    // 5 - 授权失败
    // 6 - 主体信息不相同(包含关联企业)
    // 7 - 企微未认证主体信息(包含关联企业)

    switch (status) {
        case 1:
            dialog = showDialog({
                title: '系统异常，请重试',
                onlyConfirmBtn: true,
                confirmText: '重试',
                confirm: reInstallhandle
            });
            break;
        case 2:
            dialog = showDialog({
                // eslint-disable-next-line no-unused-vars
                titleRender(h) {
                    return (
                        <p class="v-dialog__title">
                            应用授权失败，请使用已绑定的企业微信「
                            <span style="color:#ff8345">{corpName}</span>」来扫码安装应用
                        </p>
                    );
                },
                onlyConfirmBtn: true,
                confirmText: '重试授权安装',
                confirm: reInstallhandle
            });
            break;
        case 3:
            dialog = showDialog({
                title: '主体信息不同，应用授权失败\n请更换企业微信，或更换主体信息后重新验证',
                // eslint-disable-next-line no-unused-vars
                render(h) {
                    return (
                        <p class="app-install-error-dialog-text app-install-error-dialog-text-left">
                            企业微信和企点的主体信息必须相同，可以执行以下任一操作来更换主题信息：
                            <br />
                            1、
                            <a href="https://work.weixin.qq.com/wework_admin/auth_index" target="_blank">
                                更换企业微信主体信息
                            </a>
                            <br />
                            2、联系经销商更换企点主体信息
                        </p>
                    );
                },

                // eslint-disable-next-line no-unused-vars
                additionalFooterRender(h) {
                    const className = isBind
                        ? 'app-install-error-dialog-tip'
                        : 'app-install-error-dialog-tip app-install-error-dialog-tip-right';
                    return <p class={className}>更换主体信息后再点击此按钮</p>;
                },
                confirmText: isBind ? '重新验证' : '更换企业微信',
                cancelText: '重新验证',
                onlyConfirmBtn: isBind,
                confirm() {
                    if (isBind) {
                        getAppInstallResult(originOptions);
                    } else {
                        showWeworkQuitDialog();
                    }
                },
                cancel() {
                    getAppInstallResult(originOptions);
                }
            });

            setMaxWidthDialog(dialog, 400);
            addDialogClass(dialog, 'app-install-error-btn-170');
            break;
        case 4:
            dialog = showDialog({
                title: '您的企业微信未认证主体信息，应用授权失败\n请更换企业微信，或认证主体信息后重新验证',
                // eslint-disable-next-line no-unused-vars
                render(h) {
                    return (
                        <p class="app-install-error-dialog-text">
                            请使用注册企点的主体信息来
                            <a href="https://work.weixin.qq.com/wework_admin/auth_index" target="_blank">
                                认证企业微信
                            </a>
                        </p>
                    );
                },

                // eslint-disable-next-line no-unused-vars
                additionalFooterRender(h) {
                    const className = isBind
                        ? 'app-install-error-dialog-tip'
                        : 'app-install-error-dialog-tip app-install-error-dialog-tip-right';
                    return <p class={className}>更换主体信息后再点击此按钮</p>;
                },
                confirmText: isBind ? '重新验证' : '更换企业微信',
                cancelText: '重新验证',
                onlyConfirmBtn: isBind,
                confirm() {
                    if (isBind) {
                        getAppInstallResult(originOptions);
                    } else {
                        showWeworkQuitDialog();
                    }
                },
                cancel() {
                    getAppInstallResult(originOptions);
                }
            });
            setMaxWidthDialog(dialog, 400);
            addDialogClass(dialog, 'app-install-error-btn-170');
            break;
        case 5:
            dialog = showDialog({
                title: '应用授权失败，请重新授权',

                // eslint-disable-next-line no-unused-vars
                render(h) {
                    return (
                        <p>
                            重新授权前，请先在「
                            <a href="https://work.weixin.qq.com/wework_admin/frame#apps" target="_blank">
                                企业微信后台-应用管理中心
                            </a>
                            」删除「{name}」应用
                        </p>
                    );
                },
                confirmText: '重试授权',
                confirm: reInstallhandle
            });
            break;
        case 6:
            dialog = showDialog({
                title: '主体信息不同，应用授权失败\n请添加一个和企业微信主体信息一致的关联企业',

                // eslint-disable-next-line no-unused-vars
                render(h) {
                    return (
                        <p class="app-install-error-dialog-text">
                            <b>如果您已添加过关联企业，请耐心等待审核通过</b> <br />
                            {isBind ? (
                                <span>或者先解绑当前企业微信账号，再绑定一个和企点主体信息相同的企业微信</span>
                            ) : (
                                <span>
                                    也可以选择和企点主体信息相同的企业微信来重新绑定 <br /> （请先退出当前企业微信的登录
                                </span>
                            )}
                        </p>
                    );
                },
                confirmText: '去添加关联企业',
                cancelText: '更换企业微信',
                onlyConfirmBtn: isBind,
                confirm() {
                    window.location.href = '/mng/account/corpInfo';
                },
                cancel() {
                    showWeworkQuitDialog();
                }
            });
            setMaxWidthDialog(dialog, 370);
            addDialogClass(dialog, 'app-install-error-btn-150');
            break;
        case 7:
            dialog = showDialog({
                title: '您的企业微信未认证主体信息，应用授权失败',

                // eslint-disable-next-line no-unused-vars
                render(h) {
                    return (
                        <p class="app-install-error-dialog-text app-install-error-dialog-text-left">
                            企业微信和企点的主体信息必须相同，可以执行以下任一操作来继续绑定：
                            <br />
                            1、去认证企业微信主体信息<b>（需和注册企点的主体信息或任一关联企业信息相同）</b>
                            <br />
                            {isBind ? (
                                <span> 2、先解绑当前企业微信账号，再绑定一个和企点主体信息相同的企业微信</span>
                            ) : (
                                <span>
                                    2、更换一个和企点主体信息相同的企业微信来重新认证
                                    <b>（请先退出当前企业微信的登录）</b>
                                </span>
                            )}
                        </p>
                    );
                },
                confirmText: '去认证企业微信',
                cancelText: '更换企业微信',
                onlyConfirmBtn: isBind,
                confirm() {
                    window.open('https://work.weixin.qq.com/wework_admin/auth_index ');
                },
                cancel() {
                    showWeworkQuitDialog();
                }
            });
            setMaxWidthDialog(dialog, 370);
            addDialogClass(dialog, 'app-install-error-btn-150');
            break;
        default:
            dialog = showDialog({
                title: '应用授权失败，请重试',
                onlyConfirmBtn: true,
                confirmText: '重试',
                confirm: reInstallhandle
            });
    }

    addDialogClass(dialog, 'app-install-error-dialog');
}

export function handleInstallResult(options) {
    const { data, isBind, reInstallFn } = options || {};
    const { status, name, init_url: initUrl, status_comment: statusComment } = data || {};

    // status 1. 绑定成功 2.绑定失败 3.解绑
    if (status === 1) {
        if (initUrl) {
            showDialog({
                title: `您已成功授权安装「${name}」应用，请继续完成相关配置`,
                onlyConfirmBtn: 'true',
                confirmText: '去配置',
                confirm() {
                    window.open(initUrl);
                }
            });
        }
    } else if (status === 2) {
        handleErrorResult({
            statusCommentObj: JSON.parse(statusComment),
            isBind,
            name,
            reInstallFn,
            originOptions: options
        });
    }
}
